import React, { useState, useEffect } from 'react'
import { Sidebar } from '../../components/Sidebar/Sidebar'
import DataTable from 'react-data-table-component'
import { Link } from 'react-router-dom'
import axios from 'axios'
import { Baseurl } from '../../../Config/Baseurl'
import moment from 'moment'
import Tippy from '@tippyjs/react'
import 'tippy.js/dist/tippy.css'
import { CSVLink } from 'react-csv'
import { MdEdit } from 'react-icons/md'

export const BillHistory = () => {
  const currentDate = new Date().toISOString().split('T')[0]

  const [data, setData] = useState([])
  const [filteredData, setFilteredData] = useState([])
  const [search, setSearch] = useState('')
  const [values, setValues] = useState({
    from: '',
    to: '',
    status: '',
  })

  // onchange input
  let name, value
  const handleChange = (e) => {
    name = e.target.name
    value = e.target.value

    setValues({ ...values, [name]: value })
  }
  const getData = async () => {
    await axios
      .get(Baseurl.nodeLocal + 'admin-approval/getApprovedRequests')
      .then((res) => {
        setData(res.data.data)
        setFilteredData(res.data.data)
      })
      .catch((err) => {})
  }

  useEffect(() => {
    getData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // filter data based on dropdown selection
  useEffect(() => {
    const result = data.filter((item) => {
      const range = moment(new Date(item.initiate_date)).format('YYYY-MM-DD')
      if (values.from === '' || values.to === '') {
        return (
          item.final_status.match(values.status) &&
          item.payee_name.toLowerCase().match(search.toLowerCase())
        )
      } else if (values.from !== '' && values.to !== '') {
        return (
          moment(range).isBetween(values.from, values.to, null, '[]') &&
          item.final_status.match(values.status) &&
          item.payee_name.toLowerCase().match(search.toLowerCase())
        )
      }

      return false
    })

    setFilteredData(result)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values, search])

  // columns to display tableData
  const columns = [
    {
      name: 'Sr.no',
      selector: (row) => row.transaction_id,
      sortable: true,
      width: '75px',
    },
    {
      name: 'Employee Name',
      selector: (row) => {
        return (
          <Tippy content={row.payee_name} theme="bootstrap">
            <p
              style={{
                marginTop: '1rem',
              }}
              className="text-truncate"
            >
              {row.payee_name}
            </p>
          </Tippy>
        )
      },
      width: '130px',
    },
    {
      name: 'Employee ID',
      selector: (row) => {
        return (
          <Tippy content={row.desig_id} theme="bootstrap">
            <p
              style={{
                marginTop: '1rem',
              }}
              className="text-truncate"
            >
              {row.desig_id}
            </p>
          </Tippy>
        )
      },
      width: '120px',
    },

    {
      name: 'Paid Amount',
      selector: (row) => row.paid_amount,
    },
    {
      name: 'Payment Mode',
      selector: (row) => row.mode_name,
    },

    {
      name: 'HR Status',
      selector: (row) => row.status,
    },
    {
      name: 'Final Status',
      selector: (row) => row.final_status,
      width: '120px',
    },
    {
      name: 'Approved By',
      selector: (row) => row.hr_approved_by,
    },

    {
      name: 'Approved Date',
      selector: (row) => {
        if (row.hr_approved_date === 'Pending') {
          return <p className="mt-3">Pending</p>
        } else {
          return moment(
            new Date(row.hr_approved_date).toISOString().split('T')[0],
          ).format('DD-MM-YYYY')
        }
      },
    },
    {
      name: 'Initiated Date',
      selector: (row) => {
        return moment(
          new Date(row.initiate_date).toISOString().split('T')[0],
        ).format('DD-MM-YYYY')
      },
    },
    {
      name: 'Action',
      cell: (row) => {
        return (
          <>
            <Link to={'/adminrequest/' + row.transaction_id} className="link">
              <MdEdit className="editbtn" />
            </Link>
          </>
        )
      },
    },
  ]

  const onPageChange = (pageIndex) => {
    global.billPageNumber = pageIndex
  }

  return (
    <div className="billhistory row">
      <div className="col-md-2">
        <Sidebar />
      </div>
      <div className="billhistoryContainer col-md-9 mt-2">
        {/* bread Crumbs */}
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb p-3">
            <li className="breadcrumb-item">
              <Link to="/admindashboard" className="link text-primary">
                Home
              </Link>
            </li>

            <li className="breadcrumb-item active" aria-current="page">
              Latest Requests
            </li>
          </ol>
        </nav>
        <div className="w-100  d-flex justify-content-end">
          <div className="row" style={{ width: '50rem' }}>
            <div className="col-md-3">
              <input
                type="text"
                placeholder="Search Here..."
                className="mt-4 form-control"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
            <div className="col-md">
              <h6 htmlFor="exampleFormControlInput1" className="form-label">
                From
              </h6>
              <input
                type="date"
                className="form-control"
                name="from"
                value={values.from}
                onChange={handleChange}
                max={new Date().toISOString().split('T')[0]}
              />
            </div>
            <div className="col-md">
              <h6 htmlFor="exampleFormControlInput1" className="form-label">
                To
              </h6>
              <input
                type="date"
                className="form-control"
                name="to"
                value={values.to}
                onChange={handleChange}
                max={new Date().toISOString().split('T')[0]}
              />
            </div>
            <div className="col-md">
              <h6 htmlFor="exampleFormControlInput1" className="form-label">
                Status
              </h6>
              <select
                className="form-select"
                id="floatingSelectGrid"
                name="status"
                value={values.status}
                onChange={handleChange}
              >
                <option value="" disabled selected>
                  {' '}
                  Select{' '}
                </option>
                <option value="Approved"> Approved </option>
                <option value="Pending"> Pending </option>
                <option value="On Hold"> On Hold </option>
                <option value="Rejected"> Rejected </option>
                <option value="Payment Done"> Payment Done </option>
              </select>
            </div>
          </div>
        </div>

        <div>
          <div className="d-flex align-items-end justify-content-end mb-4 mt-2">
            {/* export data in csv format */}
            <CSVLink
              data={filteredData}
              filename={'Reimbursement requests - ' + currentDate}
            >
              <button className="btn btn-primary btn-sm" type="button">
                Export
              </button>
            </CSVLink>
            <button
              className="btn btn-outline-secondary mx-2 btn-sm"
              type="button"
              onClick={() => {
                setValues({ from: '', to: '', status: '' })
                setSearch('')
              }}
            >
              Clear
            </button>
          </div>
        </div>

        {/* data table */}
        <DataTable
          title="Latest Requests"
          columns={columns}
          data={filteredData}
          pagination
          highlightOnHover
          onChangePage={onPageChange}
          paginationDefaultPage={
            global.billPageNumber ? global.billPageNumber : 1
          }
        />
      </div>
    </div>
  )
}
